var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M32.45 9.828H17a.55.55 0 0 1-.55-.552V7.07a.55.55 0 0 1 .55-.551h15.45a.55.55 0 0 1 .55.551v2.207a.55.55 0 0 1-.55.552",
    stroke: "current",
    strokeWidth: 1.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.723 3.207v3.31M28.585 1l-3.862 2.207",
    stroke: "current",
    strokeWidth: 1.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.311 33H3.76c-.61 0-1.104-.494-1.104-1.104V29.69h18.759v2.207c0 .61-.494 1.104-1.104 1.104m1.625-3.311H2.133A1.133 1.133 0 0 1 1 28.556v-1.045c0-.626.507-1.133 1.133-1.133h19.803c.626 0 1.133.507 1.133 1.133v1.045c0 .625-.507 1.132-1.133 1.132M2.754 21.414c-.814 0-1.569.544-1.724 1.343-.201 1.038.628 1.915 1.625 1.967.955.05 1.655-.711 1.655-1.655h2.76a1.655 1.655 0 1 0 3.31 0h3.31a1.655 1.655 0 1 0 3.311 0h2.759c0 .944.7 1.706 1.655 1.655.895-.047 1.655-.759 1.655-1.655 0-.862-.793-1.655-1.655-1.655zm9.281-8.828C5.413 12.586 1 14.862 1 18.103v.545c0 .309.25.559.558.559h20.953c.308 0 .558-.25.558-.559v-.545c0-3.241-4.414-5.517-11.034-5.517",
    stroke: "current",
    strokeWidth: 1.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m17 9.827.157 3.302c3.671.857 5.912 2.669 5.912 4.974v.545c0 .308-.25.558-.558.558h-1.097v2.207c.862 0 1.655.793 1.655 1.656 0 .896-.76 1.608-1.655 1.655v1.655h.522c.626 0 1.133.507 1.133 1.133v1.044c0 .626-.507 1.133-1.133 1.133h-.522v2.207c0 .61-.494 1.104-1.104 1.104h9.984c.588 0 1.073-.462 1.101-1.05l1.053-22.123z",
    stroke: "current",
    strokeWidth: 1.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M24.724 14.793c-.987 0-1.895.328-2.63.876.627.72.975 1.538.975 2.434v.545c0 .309-.25.559-.558.559h-1.097v2.207c.862 0 1.655.792 1.655 1.655 0 .074-.012.146-.023.217a4.4 4.4 0 0 0 1.678.335 4.414 4.414 0 0 0 0-8.828",
    stroke: "current",
    strokeWidth: 1.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryMenuIcon);
export default __webpack_public_path__ + "static/media/categoryMenuIcon.5cdada2a8074cc9c799d1a37679e1444.svg";
export { ForwardRef as ReactComponent };